import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const ASSESSMENT_MODE_ROUTE = {
  name: 'assessmentmode/:activityId/:questionOrder',
  route(classId: string, activityId: string, questionOrder: string | null): (string | null)[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), 'assessmentmode', activityId, questionOrder];
  }
};
